/**
 * Test IDs registry. Use kebab-case strings everywhere — direct usage is encouraged.
 * Centralized references for repeated elements.
 */
export const TID = {
  navHome: "nav-home",
  navAbout: "nav-about",
  navPoojas: "nav-poojas",
  navKnowledge: "nav-knowledge",
  navGallery: "nav-gallery",
  navContact: "nav-contact",
  navBook: "nav-book",
  navAdmin: "nav-admin",
  heroBookBtn: "hero-book-btn",
  heroExploreBtn: "hero-explore-btn",
  langSwitcher: "lang-switcher",
  footer: "site-footer",
};
